import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpResponse, type HttpEvent, type HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { UserSelectService } from '@app/services/user-select.service';

/**
 * Clears the cached users + group/workplace lists whenever a user or group is
 * created / edited / (de)activated / removed, so stale lists aren't served from
 * the UserSelectService cache after a mutation. Covers both organization and clients.
 */
@Injectable()
export class CacheInvalidationInterceptor implements HttpInterceptor {
  // Only the user/group MANAGEMENT endpoints. The `\b` before/after the segment means
  // `_users` (e.g. risk_assessments_users assignment endpoints) is NOT matched.
  private readonly userOrGroupMgmt = /\/api\/v1\/(organization\/|clients\/)?(users|groups)\b/;
  private readonly mutatingMethods = ['POST', 'PUT', 'PATCH', 'DELETE'];

  constructor(private userSelectService: UserSelectService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const shouldInvalidate =
      this.mutatingMethods.includes(request.method) && this.userOrGroupMgmt.test(request.url);

    if (!shouldInvalidate) {
      return next.handle(request);
    }

    return next.handle(request).pipe(
      tap(event => {
        if (event instanceof HttpResponse && event.status >= 200 && event.status < 300) {
          this.userSelectService.invalidateUsersAndGroups();
        }
      })
    );
  }
}
